// mirrors operations.constants.FILE_STATUS on the backend
export const FILE_STATUS_UNPROCESSED = "U";
